<template>
    <span :class="classes">
        <div class="notification__text--container">
            <h5 class="notification__text">
                <slot name="title"></slot>
            </h5>
            <p class="body-1 notification__text">
                <slot name="details"></slot>
            </p>
        </div>
        <i v-if="flash" @click="closeMessage" class="fas fa-times flash-message__close js-flash-close"></i>
    </span>
</template>

<script>
export default {
    props: {
        type: { type: String, },
        flash: { type: Boolean, default: false },
    },
    computed: {
        classes () {
            const { type, flash } = this
            
            return [
                ...(flash ? [`flash-message flash-message--${type}`] : [`notification notification--${type}`]),
            ]
        },
    },
    methods: {
        closeMessage(e) {
            const el = e.target.parentElement;
            el.style.opacity = "0";
            el.style.transition = 0.5 + "s opacity";

            setTimeout(function () {
                el.style.display = "none";
            }, 500)
        }
    }
}
</script>

<style>

</style>